import React from 'react';
import classnames from 'classnames/bind';

export default class Dropdown extends React.Component {
    state = {
        open: false
    };

    render() {
        return (
            <div className={classnames("dropdown", {'is-open': this.state.open})} >
                <this.props.trigger onClick={() => this.setState({...this.state, open: !this.state.open})} />
                <ul className="content" onMouseLeave={() => this.setState({...this.state, open: false})}>
                    {this.props.children}
                </ul>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/common/Dropdown.js